import React, { useState } from 'react';
import { Modal, ModalBody} from 'reactstrap';
import { Button } from 'components/ui';
import masterCard from 'assets/images/master-card.png';
import visa from 'assets/images/visa.png';
import discover from 'assets/images/discover.png';
import amex from 'assets/images/amex.png';
import styles from './PaymentCard.module.scss';
import clsx from 'clsx';
import paymentIcon from 'assets/images/payment_icon.png';
import { useFetcher, fetcher } from 'utils/fetcher';
import { CustomerPaymentMethods } from 'types/stripe';
import { Radio } from 'components/ui';
import cookies from '../../../store/apis/cookies'
import deleteNew from 'assets/images/delete_new.png'
import sucessNewImg from'assets/images/sucess_new_btn.png'
import { paymentsFetch } from 'store/actions/paymentMethods';
import { useDispatch } from 'react-redux';

type PaymentCardProps = {
  // makeDefault: (value: string, b: boolean) => void;
  isDefault: boolean;
  cardId: string;
  cardNumber: string;
  handleEditCard: () => void;
  radioValue: string;
  type: string;
  mutate: () => void;
};

export const PaymentCard: React.FC<PaymentCardProps> = ({
  cardId,
  isDefault,
  cardNumber,
  handleEditCard,
  // makeDefault,
  radioValue,
  type,
  mutate
}) => {
  const dispatch = useDispatch();
  
  const [isModalOpen, setModal] = useState<boolean>(false);
  const [isApplyAll, setApplyAll] = useState<boolean>(false);
  const [isAllRequestAlreadyFilled, setAllRequestAlreadyFilled] = useState<boolean>(false);
  const [isPaymentDefault, setPaymentDefault] = useState<boolean>(isDefault);
  const [fetchRequestData, setFetchRequestData] = useState<any>();
  const [selectedPaymentId, setSelectedPaymentId] = useState(Array(fetchRequestData?.data.length).fill(null));
  const [paymentCards, setPaymentCardId] = useState(Array(fetchRequestData?.data.length).fill(null));
  const [openAccordions, setOpenAccordions] = useState(Array(fetchRequestData?.data.length).fill(false));
  const [isSuccessModalOpen, setSuccessModalOpen] = React.useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(false);
  const [processing, setProcessing] = React.useState(false);

  function cardType() {
    switch (type) {
      case 'masterCard':
        return masterCard;
      case 'discover':
        return discover;
      case 'visa':
        return visa;
      case 'amex':
        return amex;
      default:
        return masterCard;
    }
  }
  function getCardType(cardType:string) {
    switch (cardType) {
      case 'masterCard':
        return masterCard;
      case 'discover':
        return discover;
      case 'visa':
        return visa;
      case 'amex':
        return amex;
      default:
        return masterCard;
    }
  }
  const toggleModal = () => {
    setModal(!isModalOpen);
    setPaymentDefault(isDefault);
  };

  const handleDelete = async () => {
    setProcessing(true);
    if(fetchRequestData?.data?.length) {
      let reqBody :any[] = []
      for (let index = 0; index < fetchRequestData.data.length; index++) {
        const requestData = fetchRequestData.data[index];
        const cardData = paymentCards[index];
        reqBody[index] = {
          'request_rid': requestData,
          'card_id': cardData.id
        }
      }

      const baseUrl = process.env.REACT_APP_BASE_API_URL
      const accessToken:any = process.env.REACT_APP_AUTHORIZATION_HEADER;
      // Create an object to represent the headers
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('authorization-token', cookies.load('authToken'));
      headers.append('authorization', accessToken);
      await fetch(baseUrl + "/api/v2/patient/cards/updated_request_with_new_card", {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify({
              "card_updates": reqBody
            })
          })
          .then((response) => response.json())
          .catch((err) => {
            console.log(err.message);
          });
    }
    await fetcher(`/api/v2/patient/cards/remove_payment_method?pm_id=${cardId}`, {
      method: 'DELETE',
    }).then((res: any) => {
      if(res.error){
        alert(res.error);
        setProcessing(false);
        setDeleteModalOpen(false);
        setModal(false)
      }
      else{
        setProcessing(false);
        setDeleteModalOpen(false);
        setModal(false)
        setPaymentCardId(Array(fetchRequestData?.data.length).fill(null));
        setSelectedPaymentId(Array(fetchRequestData?.data.length).fill(null));
        setSuccessModalOpen(true)
      }
    });
  };

  const handleSuccesfulModal = () => {
    dispatch(paymentsFetch());
    mutate();
    setSuccessModalOpen(false)
  }

  const handleRadioChange = (item:any, index:any) => {
    const paymentIds = [...selectedPaymentId];
    paymentIds[index] = item;
    setSelectedPaymentId(paymentIds);
  };

  const setRequestCard = (index:number) => {
    const allPaymentCards = [...paymentCards];
    const filledData:any = selectedPaymentId[index]
    if(filledData == null){
      alert('Please select card first')
      return null;
    }

    if(isApplyAll){
      setPaymentCardId(Array(fetchRequestData?.data.length).fill(filledData));
      setSelectedPaymentId(Array(fetchRequestData?.data.length).fill(filledData));
      setOpenAccordions(Array(fetchRequestData?.data.length).fill(false))
      setApplyAll(false)
      setAllRequestAlreadyFilled(true)
    }
    else {
      allPaymentCards[index] = filledData;
      setPaymentCardId(allPaymentCards);
      toggleAccordion(index)
      checkAllRequestFilled(allPaymentCards)
    }
  }
  const toggleAccordion = (index:any) => {
    const newOpenAccordions = [...openAccordions];
    newOpenAccordions[index] = !newOpenAccordions[index];
    setOpenAccordions(newOpenAccordions);
  };
  const checkAllRequestFilled = (allPaymentCards:any[]) => {
    if(allPaymentCards.length != fetchRequestData?.data.length){
      setAllRequestAlreadyFilled(false)
      return;
    }
    for (let index = 0; index < allPaymentCards.length; index++) {
      const element = allPaymentCards[index];
      if(element == null){
        setAllRequestAlreadyFilled(false)
        return
      }
    }
    setAllRequestAlreadyFilled(true)
  }
  const openDeleteCardModal = (payCardId: any) => {
    const baseUrl = process.env.REACT_APP_BASE_API_URL
    const apiUrl = baseUrl + '/api/v2/patient/cards/request_list_link_card?pm_id=' + payCardId + '&authorization=' + process.env.REACT_APP_AUTHORIZATION_HEADER; // Replace with your API endpoint
    const accessToken:any = process.env.REACT_APP_AUTHORIZATION_HEADER;

    // Create an object to represent the headers
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('authorization-token', cookies.load('authToken'));
    headers.append('authorization', accessToken);

    fetch(apiUrl, {
      method: 'GET',
      headers: headers
    })
      .then((response) => response.json())
      .then((data) => {
        if(data.message == ''){
          if(data.data.length){
            setFetchRequestData(data)
            setModal(!isModalOpen);
            setPaymentDefault(isDefault);
          }else{
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            setDeleteModalOpen(true);
          }
        }else{
          alert('This card is currently the payment method for your Store & Share subscription. Please update the payment method for your subscription prior to deleting this card.')
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  
  const { data: paymentMethodsData, isLoading: isLoadingPaymentMethods, mutate: mutatePaymentMethods } = useFetcher<CustomerPaymentMethods>(
    '/api/v2/patient/cards/stripe_customer_payment_methods',
  );
  
 
  const handleSave = () => {
    // if (isDefault !== isPaymentDefault) makeDefault(radioValue, isPaymentDefault);
    setModal(false);
  };
  const openDeleteModal = () =>{
    setDeleteModalOpen(true)
    setModal(!isModalOpen)
  }

  const closeCardModal = () => {
    setModal(false)
    setSelectedPaymentId(Array(fetchRequestData?.data.length).fill(null));
  }
  return (
    <div className={clsx(styles['root'], 'col-12 col-md-6 col-lg-4')}>
      <div className={styles['body']+'  crad_wrapper'}>
        <img className={styles['master-card']} src={cardType()} alt="master-card" />
        <div className={styles['number']}>{`**** **** **** ${cardNumber}`}</div>
        <div className={styles['default-payment']}>{isDefault && <div>Default</div>}</div>
        <span className={clsx(styles['edit-icon'], 'text-danger')} onClick={()=>openDeleteCardModal(radioValue)}>
          <i className="fa fa-trash-o"></i> <span style={{ fontSize: '14px' }}>Remove</span>
        </span>
      </div>

      <Modal isOpen={isModalOpen} centered toggle={toggleModal}>
        <ModalBody>
          <div className="row px-3 new-card-modal-wrapper">
            <div className='col-12 text-center mb-3'>
              <img src={paymentIcon} alt='' />
              <h1 className='payment_header_txt'>Update Payment Method for Request</h1>
              <p>This card is currently the payment method for the following request. Please update the payment method for your request prior to deleting this card.</p>
            </div>
            <div className='col-12 mt-3'>
              <div className='row'>
                <div className='col-sm-3'><strong>Request ID</strong></div>
                <div className='col-sm-6'><strong>Update Card</strong></div>
              </div>
            </div>
            <div className='col-12 mt-3'>
              <>
                {fetchRequestData ? (
                  fetchRequestData.data.map((request: any, index: number) => (
                    <div className='row' key={index}>
                      <div className='col-sm-3 d-flex align-items-top mt-2'><strong>{request}</strong></div>
                      <div className='col-sm-9'>
                        <div className='row'>
                          <div className={`payment-accordian accordion ${openAccordions[index] ? 'open' : ''}`}>
                            <div className="accordion-header" onClick={() => toggleAccordion(index)}>
                              <div className="accordion-title d-flex align-items-center">
                                {
                                  paymentCards[index] ? (
                                    <>
                                    <img className={styles['master-card']} src={getCardType(paymentCards[index]?.card?.brand)} alt={paymentCards[index]?.card?.brand} />
                                    <span className='ml-2'><strong className='text-title'>{paymentCards[index]?.card?.brand} </strong>{` ending in ${paymentCards[index].card.last4}`}</span>
                                    </>
                                  ) : 'Select a Card'
                                }
                                
                              </div>
                              <span className={`accordion-arrow ${openAccordions[index] ? 'open' : ''}`}>
                                <i className="fa fa-sort-desc" aria-hidden="true"></i>
                              </span>
                            </div>
                            <div className='card_details_container'>
                              {paymentMethodsData ? (
                                <>
                                {paymentMethodsData.data.filter( item => item.id != cardId).map((item: any) => (
                                  <div className="accordion-content" key={item.id}>
                                    <div className='col-12 card_details_wrapper d-flex align-items-center justify-content-between'>
                                      <div>
                                        <span className='card_details_new'><img className={styles['master-card']} src={getCardType(item?.card?.brand)} alt={item?.card?.brand} /></span>
                                        <span className='card_details_new ml-2'><strong  className='text-title'>{item?.card?.brand} </strong>{` ending in ${item.card.last4}`}</span>
                                      </div>
                                      <span className='card_details_new'>
                                        <Radio
                                          name={"paymentMethod" + request}
                                          value={item.id}
                                          checked={selectedPaymentId[index]?.id === item.id}
                                          onClick={() => handleRadioChange(item, index)}
                                          className={styles.radio}
                                          
                                        />
                                      </span>
                                    </div>
                                  </div>
                                ))}
                                <hr style={{marginTop: '0px', marginBottom: '0px'}}/>
                                <div className='accordion-content'>
                                  <div className='card_details_wrapper d-flex align-items-center justify-content-between mb-1 ml-2 pl-2'>
                                  <div className='pull-left'>
                                    <input type='checkbox' className='mr-2' checked={isApplyAll} onChange={() => setApplyAll(!isApplyAll)} /> <strong>Apply to all</strong>
                                  </div>
                                  <div className='pull-right btn btn-link' onClick={() => setRequestCard(index)}>Confirm</div>
                                  </div>
                                </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : null}
              </>
              <div className='row mt-4 mb-2'>
                <div className='col-6'>
                  <button className='custom-btn custom-back' onClick={closeCardModal}>Back</button>
                </div>
                <div className='col-6'>
                  <button className='custom-btn btn btn-primary' disabled={!isAllRequestAlreadyFilled} onClick={openDeleteModal}>Continue</button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal 
          isOpen={isDeleteModalOpen} 
          centered
          title="Are you sure you’d like to remove this card?">
          <ModalBody>
            <div className='row mt-4'>
              <div className='col-12 d-flex flex-column align-items-center'>
                <img src={deleteNew} alt='' style={{width: '55px'}}/>
                <h1 className='my-2'>Are you sure you want to delete this card?</h1>
                <p style={{textAlign:"center"}}>The card will be removed from your account and you’ll have to
                re-enter the informations for future use</p>
              </div>
            </div>
            <div className='row mt-4 mb-2'>
            <div className='col-6'>
              <Button onClick={() => {setDeleteModalOpen(false)}} type='bordered'>
                Cancel
              </Button>
            </div>
            <div className='col-6'>
              <Button type='danger' disabled={processing} inProgress={processing} onClick={handleDelete}>Delete</Button>
            </div>
            </div>
            
          </ModalBody>
        </Modal>
        <Modal isOpen={isSuccessModalOpen} centered>
          <ModalBody>
            <div className='row my-2'>
              <div className='col-12 d-flex flex-column align-items-center'>
                <img src={sucessNewImg} alt=''/>
                <h1 className='my-4'>Card Deleted Successfully!</h1>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <Button type='primary' onClick={handleSuccesfulModal}>Done</Button>
              </div>
            </div>
            
          </ModalBody>
        </Modal>
    </div>
  );
};


